import React, { Component } from "react";
import { Button, Dropdown, Form, Popup } from "semantic-ui-react";
import { ChromePicker } from "react-color";

export const Arial = "Arial, Helvetica, sans-serif";
export const ArialBlack = '"Arial Black", Gadget, sans-serif';
export const ComicSans = '"Comic Sans MS", cursive, sans-serif';
export const Courier = '"Courier New", Courier, monospace';
export const Georgia = "Georgia, serif";
export const Impact = "Impact, Charcoal, sans-serif";
export const LucidaConsole = '"Lucida Console", Monaco, monospace';
export const LucidaSans = '"Lucida Sans Unicode", "Lucida Grande", sans-serif';
export const Palatino = '"Palatino Linotype", "Book Antiqua", Palatino, serif';
export const Tahoma = "Tahoma, Geneva, sans-serif";
export const Times = '"Times New Roman", Times, serif';
export const Trebuchet = '"Trebuchet MS", Helvetica, sans-serif';
export const Verdana = "Verdana, Geneva, sans-serif";

const supportedFonts = [
  { value: Arial, text: "Arial", style: { fontFamily: Arial } },
  { value: ArialBlack, text: "Arial Black", style: { fontFamily: ArialBlack } },
  { value: ComicSans, text: "Comic Sans", style: { fontFamily: ComicSans } },
  { value: Courier, text: "Courier", style: { fontFamily: Courier } },
  { value: Georgia, text: "Georgia", style: { fontFamily: Georgia } },
  { value: Impact, text: "Impact", style: { fontFamily: Impact } },
  {
    value: LucidaConsole,
    text: "Lucida Console",
    style: { fontFamily: LucidaConsole }
  },
  { value: LucidaSans, text: "Lucida Sans", style: { fontFamily: LucidaSans } },
  { value: Palatino, text: "Palatino", style: { fontFamily: Palatino } },
  { value: Tahoma, text: "Tahoma", style: { fontFamily: Tahoma } },
  { value: Times, text: "Times", style: { fontFamily: Times } },
  { value: Trebuchet, text: "Trebuchet", style: { fontFamily: Trebuchet } },
  { value: Verdana, text: "Verdana", style: { fontFamily: Verdana } }
];

const invertColor = (hex, bw) => {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    throw new Error("Invalid HEX color.");
  }
  var r = parseInt(hex.slice(0, 2), 16),
    g = parseInt(hex.slice(2, 4), 16),
    b = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
  }
  // invert color components
  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16);
  // pad each with zeros and return
  return "#" + padZero(r) + padZero(g) + padZero(b);
};
const padZero = (str, len) => {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
};

export const textElement = {
  color: "#333333",
  display: "block",
  fontFamily: Arial,
  fontSize: "96px",
  fontWeight: "bold",
  height: "auto",
  left: "0",
  lineHeight: "110px",
  position: "absolute",
  textAlign: "center",
  top: "0px",
  width: "100%",
  content: "Text",
  caption: "",
  captionPosition: "top",
  label: "Text",
  type: "text",
  editable: true
};

class TextForm extends Component {
  state = {};
  fontColorToggle = () =>
    this.setState({ fontColorOpen: !this.state.fontColorOpen });
  fontColorRef = fontColor => this.setState({ fontColor });
  render() {
    const { fontColor, fontColorOpen } = this.state;
    const { element: elem, id: i, update, title, delete: trash } = this.props;
    return (
      <Form>
        <Popup
          basic
          open={fontColorOpen}
          context={fontColor}
          style={{ padding: 0, boxShadow: 0 }}
          content={
            <ChromePicker
              color={elem["color"]}
              onChangeComplete={(color, e) => update(i, "color", color.hex)}
            />
          }
          on="click"
          position="bottom center"
          onClose={this.fontColorToggle}
        />
        <h5>{title}</h5>
        {elem.editable && (
          <Form.Field>
            <label>Content</label>
            <input
              name={`element-${i}-content`}
              value={elem["content"]}
              onChange={e => update(i, "content", e.target.value)}
            />
          </Form.Field>
        )}
        <Form.Field>
          <label>Caption</label>
          <input
            name={`element-${i}-caption`}
            value={elem["caption"]}
            onChange={e => update(i, "caption", e.target.value)}
          />
        </Form.Field>
          <label>Caption position</label>
        <Form.Group>
          <Button.Group widths="4">
            <Button
              icon="arrow up"
              onClick={e => update(i, "captionPosition", "top")}
              active={elem["captionPosition"] === "top"}
            />
            <Button
              icon="arrow left"
              onClick={e => update(i, "captionPosition", "left")}
              active={elem["captionPosition"] === "left"}
            />
            <Button
              icon="arrow down"
              onClick={e => update(i, "captionPosition", "bottom")}
              active={elem["captionPosition"] === "bottom"}
            />
            <Button
              icon="arrow right"
              onClick={e => update(i, "captionPosition", "right")}
              active={elem["captionPosition"] === "right"}
            />
          </Button.Group>
        </Form.Group>
        <h5>Font</h5>
        <Form.Field>
          <Dropdown
            text={elem["fontFamily"]}
            style={{ fontFamily: elem["fontFamily"] }}
            selection
            options={supportedFonts}
            value={elem["fontFamily"]}
            onChange={(e, { value }) => {
              update(i, "fontFamily", value);
            }}
          />
        </Form.Field>
        <Form.Group>
          <Button.Group>
            <Button
              icon="align left"
              onClick={e => update(i, "textAlign", "left")}
              active={elem["textAlign"] === "left"}
            />
            <Button
              icon="align center"
              onClick={e => update(i, "textAlign", "center")}
              active={elem["textAlign"] === "center"}
            />
            <Button
              icon="align right"
              onClick={e => update(i, "textAlign", "right")}
              active={elem["textAlign"] === "right"}
            />
          </Button.Group>
          &nbsp;
          <Button.Group>
            <Button
              icon="bold"
              onClick={e =>
                update(
                  i,
                  "fontWeight",
                  elem["fontWeight"] === "bold" ? "normal" : "bold"
                )
              }
              active={elem["fontWeight"] === "bold"}
            />
          </Button.Group>
          &nbsp;
          <span context={fontColor} ref={this.fontColorRef}>
            <Button
              icon="font"
              content={elem["color"]}
              onClick={this.fontColorToggle}
              style={{
                backgroundColor: elem["color"],
                color: invertColor(elem["color"], 1)
              }}
            />
          </span>
        </Form.Group>
        <Form.Field inline>
          <label style={{ width: "100px" }}>Size {elem["fontSize"]}</label>
          <input
            type="range"
            min="24"
            max="280"
            step="14"
            name={`element-${i}-fontSize`}
            value={elem["fontSize"].replace("px", "")}
            onChange={e => {
              let lineHeight = parseInt(e.target.value) + 14;
              update(i, {
                fontSize: `${e.target.value}px`,
                lineHeight: `${lineHeight}px`
              });
            }}
          />
        </Form.Field>
        <h5>Position</h5>
        <Form.Field inline>
          <label style={{ width: "100px" }}>top {elem["top"]}</label>
          <input
            type="range"
            min="0"
            max={1080 - elem["lineHeight"].replace("px", "")}
            step="1"
            name={`element-${i}-top`}
            value={elem["top"].replace("px", "")}
            onChange={e => update(i, "top", `${e.target.value}px`)}
          />
        </Form.Field>
        <Form.Field inline>
          <label style={{ width: "100px" }}>left: {elem["left"]}</label>
          <input
            type="range"
            min="0"
            max="960"
            step="1"
            name={`element-${i}-left`}
            value={elem["left"].replace("px", "")}
            onChange={e => {
              let width = 1920 - e.target.value;
              update(i, {
                left: `${e.target.value}px`,
                width: `${width}px`
              });
            }}
          />
        </Form.Field>
        {trash && (
          <Button
            fluid
            color="red"
            icon="trash"
            onClick={e => {
              trash(i);
            }}
          />
        )}
      </Form>
    );
  }
}

export default TextForm;
